export interface Branding {
  productName: string;
  logo?: string;
  favicon?: string;
  accent?: string;
}

// const AAAL_BRANDING = {
//   productName: "AAAL",
//   logo: "https://demo-highlevel.s3.ap-south-1.amazonaws.com/workspaces/cmosj5ufj000401p2coz01htz/media/c14fa76978f25a5e/logo.jpeg",
//   favicon: "https://demo-highlevel.s3.ap-south-1.amazonaws.com/workspaces/cmosj5ufj000401p2coz01htz/media/c14fa76978f25a5e/logo.jpeg",
//   // accent: "#ff5722"
// };

export const DEFAULT_BRANDING: Branding = {
  productName: "Techvanch",
  logo: "https://techvanch.com/android-chrome-512x512.png",
  favicon: "https://techvanch.com/favicon-32x32.png",
  // accent: "#22ff61ff"
};

const BRANDING_BY_HOST: Record<string, Branding> = {
  // Example:
  // "crm.aaalgreensenergy.live": AAAL_BRANDING
};

export function resolveBranding(hostname?: string): Branding {
  const host = (hostname ?? (typeof window !== "undefined" ? window.location.hostname : "")).toLowerCase();
  // return BRANDING_BY_HOST[host] ?? AAAL_BRANDING ?? DEFAULT_BRANDING;
  return BRANDING_BY_HOST[host] ?? DEFAULT_BRANDING;
}
